module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "sl-qrcode"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.QrCode.title')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-merchant-qrcode"
  }, _vm._l((_vm.qrcodeData), function(item) {
    return _c('div', {
      staticClass: "sl-qrimg"
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    }), _vm._v(" "), _c('sl-a', {
      staticClass: "sl-el-btn el-button",
      attrs: {
        "href": item,
        "text": _vm.$t('Views.QrCode.download')
      },
      nativeOn: {
        "click": function($event) {
          _vm.$ga.event('Button', 'Download', 'QrCode')
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "sl-store-qrcode"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.QrCode.storeTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-store-qrcode-checkbox"
  }, [_c('el-checkbox-group', {
    staticClass: "sl-checkbox-group",
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.checkedBoxes),
      callback: function($$v) {
        _vm.checkedBoxes = $$v
      },
      expression: "checkedBoxes"
    }
  }, _vm._l((_vm.stores), function(item) {
    return _c('el-checkbox', {
      key: item.storeId,
      attrs: {
        "label": item.storeId
      }
    }, [_c('span', [_vm._v(_vm._s(item.storeName))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('img', {
      staticClass: "sl-hover-qrcode",
      attrs: {
        "src": item.qrcodeUrl,
        "alt": ""
      },
      slot: "content"
    }), _vm._v(" "), _c('img', {
      staticClass: "sl-mini-qrcode",
      attrs: {
        "src": require("../../assets/imgs/qrcode_active.png"),
        "alt": ""
      }
    })])], 1)
  })), _vm._v(" "), _c('el-checkbox', {
    staticClass: "sl-select-all",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkDownload($event)
      }
    }
  })], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f9da744e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/qrcodes.vue
// module id = 1134
// module chunks = 1